<template>
  <div>
    <!-- Barre supérieure avec les informations de contact et les icônes de réseaux sociaux -->
    <div class="top-bar">
      <div class="contact-info">
       <span class="email"><i class="fas fa-map-marker-alt"></i> 12 Bd Hassan Al Alaoui Rés. Nissrine – Ain Borja, Casablanca</span>
        <span class="phone"><i class="fas fa-phone"></i> +212 522 600 506 / +212 522 620 507</span>
        <span class="email"><i class="fas fa-envelope"></i> info@supracare.ma</span>
      </div>
      <span class="hours"><i class="fas fa-clock"></i> Lun-Ven 08h30 - 18h30 Sam 08h30 - 13h00</span>
      <div class="social-icons">
        <a href="https://facebook.com" target="_blank"><i class="fab fa-facebook-f"></i></a>
        <a href="https://twitter.com" target="_blank"><i class="fab fa-twitter"></i></a>
        <a href="https://linkedin.com" target="_blank"><i class="fab fa-linkedin-in"></i></a>
        <a href="https://instagram.com" target="_blank"><i class="fab fa-instagram"></i></a>
      </div>
    </div>

    <!-- Barre avec Logo, Recherche et Options utilisateur -->
    <div class="header-middle">
      <div class="logo-container">
        <router-link to="/">
          <img src="@/assets/logo.png" alt="Logo" class="logo-image" />
        </router-link>
      </div>

      <!--<div class="search-container">
        <input type="text" placeholder="Rechercher..." class="search-bar" />
        <i class="fas fa-search search-icon"></i>
      </div>-->
        <div class="search-container">
    <input
      type="text"
      v-model="searchQuery"
      @keyup.enter="searchProducts"
      placeholder="Rechercher un produit..."
      class="search-bar"
    />
    <i class="fas fa-search search-icon" @click="searchProducts"></i>
  </div>

  <div class="product-grid">
    <div 
      v-for="product in products" 
      :key="product._id" 
      class="product-item"
    >
      <img :src="product.image" alt="Produit" class="product-image" />
      <h3 class="product-name">{{ product.name }}</h3>
      <p class="product-price">{{ product.price }} DH</p>
    </div>
  </div>

      <div class="user-options">
         
        <router-link to="/panier" class="option-item">
        <Header />
        </router-link>

<!-- Icône Favoris avec badge -->
<router-link to="/wishlist" class="option-item1 wishlist-icon">
  <div class="icon-badge-wrapper">
    <i class="fas fa-heart"></i>
    <span v-if="wishlistCount > 0" class="badge">{{ wishlistCount }}</span>
  </div>
  <span>Liste de souhaits</span>
</router-link>


<!-- Section utilisateur connecté  -->

    <!-- CLIENT CONNECTÉ -->
    <div v-if="isLoggedIn && userRole === 'account'" class="user-dropdown">
      <button @click="toggleDropdown" class="option-item">
        <i class="fas fa-user cart-icon"></i>
        <span>{{ userName }}</span>
      </button>
      <ul class="dropdown-menu" v-show="showDropdown">
        <li><router-link to="/account">Mon compte</router-link></li>
        <li><router-link to="/wishlist">Mes souhaits</router-link></li>
        <li><a href="#" @click.prevent="logout">Se déconnecter</a></li>
      </ul>
    </div>

    <!-- ADMIN CONNECTÉ -->
    <div v-else-if="isLoggedIn && userRole === 'admin'" class="user-dropdown">
      <button @click="toggleDropdown" class="option-item">
        <i class="fas fa-user-shield cart-icon"></i>
        <span>Admin</span>
      </button>
      <ul class="dropdown-menu" v-show="showDropdown">
        <li><router-link to="/dashboardAdmin">Tableau de bord</router-link></li>
        <li><a href="#" @click.prevent="logout">Se déconnecter</a></li>
      </ul>
    </div>


<!-- Section utilisateur non connecté -->
<router-link v-else to="/connexion" class="option-item1">
  <i class="fas fa-user cart-icon"></i> CONNEXION
</router-link>

      </div>
      <!-- Bouton Shop en Ligne -->
       <div @click="closeNav">
  <router-link to="/shop" class="shop-button">
    Shop en Ligne
  </router-link>

       </div>

    </div>

    <!-- Navigation principale -->
    <nav class="navbar">
     
    <!-- Ton code existant -->
    
    <!-- Ajouter l'image du QR code 
      <div class="qr-code-section">
    <img src="@/assets/QR CERTIF.jpeg" alt="QR Code Certificat" class="qr-code-image" />
    <p>Scannez QR pour voir le certificat</p>
     </div>
     -->
      <ul :class="['nav-links', { 'nav-active': isNavOpen }]">

         <li>
          <DropdownComponent @navigateToProducts="navigateToProducts" />
        </li>
          <li @click="closeNav">

    <a href="http://www.supracare.ma" target="_blank">Présentation</a>
  </li>
        <li @click="closeNav"><a href="http://www.supracare.ma/services" target="_blank">Grantie</a></li>
        <li @click="closeNav"><router-link to="/marques">Marques</router-link></li>
        <!-- Ajout de Mon Panier et Contact au menu -->
        <li @click="closeNav">
        <a href="http://www.supracare.ma/contact" target="_blank">Contact</a>
    </li>
  </ul>


       <!-- Menu Button et Sidebar -->
    <!-- Bouton menu flottant (visible uniquement sur mobile) -->
<button class="menu-floating" @click="toggleSidebar" aria-label="Ouvrir le menu">
  <i :class="isSidebarOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
</button>



    <!-- Sidebar Component -->
    <Sidebar :isOpen="isSidebarOpen" @closeSidebar="toggleSidebar" />
    
    </nav>
<!-- Icône WhatsApp avec transition douce -->
<transition name="fade">
  <a
    v-if="!isAdminPage"
    href="https://wa.me/+212662297001"
    target="_blank"
    class="whatsapp-icon"
    title="Envoyez-nous un message"
  >
    <i class="fab fa-whatsapp"></i>
  </a>
</transition>


  </div>
</template>

<script>
import { store } from "@/Store";
import { wishlistStore } from "@/wishlisteStore.js"; // Ajoute ceci
import DropdownComponent from "@/components/DropdownComponent.vue";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/Header.vue"; 
import axios from "axios";

export default {
  name: "NavbarI",
  components: { DropdownComponent, Sidebar, Header },
  data() {
    return {
      isSidebarOpen: false,
      isNavOpen: false,
      isLoggedIn: false,
      userName: "",
      showDropdown: false,
      userRole: "",
      cart: [],
      searchQuery: "",
      products: [],
    };
  },

  // les deux stores : panier & wishlist
  computed: {
    cartCount() {
      return store.cartCount;
    },
    wishlistCount() {
      return wishlistStore.count; 
    },
    isAdminPage() {
    
    // Cache le bouton WhatsApp sur toutes les pages admin
    return this.$route.path.includes("dashboardAdmin") ||
           this.$route.path.includes("adminOrders") ||
           this.$route.path.includes("products") ||
           this.$route.path.includes("clients") ||
           this.$route.path.includes("settings");
  },
  },

  methods: {
    addToCart(p) {
      this.cart.push(p);
    },
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },
    closeNav() {
      this.isNavOpen = false;
    },
    navigateToProducts() {
      this.$router.push("/produits");
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },

    checkUserStatus() {
      const s = sessionStorage.getItem("user");
      if (s) {
        const u = JSON.parse(s);
        this.userName = `${u.prenom} ${u.nom}`;
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
        this.userName = "";
      }
    },

    // --- AUTO THEME ---
    setThemeFromSystem() {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      const finalTheme = prefersDark ? "dark" : "light";
      const html = document.documentElement;
      html.classList.add("theme-fade");
      html.setAttribute("data-theme", finalTheme);
      setTimeout(() => html.classList.remove("theme-fade"), 220);
    },
    enableAutoTheme() {
      this.setThemeFromSystem();
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const handler = () => this.setThemeFromSystem();
      mq.addEventListener ? mq.addEventListener("change", handler) : mq.addListener(handler);
    },
    // ---
        loadUserData() {
      const userData = sessionStorage.getItem("user");
      if (userData) {
        const user = JSON.parse(userData);
        this.isLoggedIn = true;
        this.userRole = user.role;
        this.userName = `${user.prenom || ""} ${user.nom || ""}`.trim();
      } else {
        this.isLoggedIn = false;
        this.userRole = "";
        this.userName = "";
      }
    },


    toggleDropdown() {
       this.showDropdown = !this.showDropdown;
    },

    logout() {
      sessionStorage.clear();
      this.isLoggedIn = false;
      this.userName = "";
      wishlistStore.setCount(0); 
      this.$router.push("/connexion");
    },

    handleResize() {
      if (window.innerWidth >= 1040 && this.isSidebarOpen) {
        this.isSidebarOpen = false;
      }
    },
    
    watch: {
    //  Si sessionStorage change (ex: connexion ou déconnexion dans une autre page)
    '$route'() {
      this.loadUserData();
    }
  },
    async searchProducts() {
      try {
        const res = await axios.get(
          `http://localhost:2028/api/products?search=${this.searchQuery}`
        );
        this.products = res.data;
      } catch (error) {
        console.error("Erreur lors de la recherche :", error);
      }
    },
    async getAllProducts() {
      try {
        const res = await axios.get("http://localhost:2028/api/products");
        this.products = res.data;
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    },


    async fetchWishlistCount() {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          wishlistStore.setCount(0);
          return;
        }

        const response = await axios.get("http://localhost:2028/api/wishlist", {
          headers: { Authorization: `Bearer ${token}` },
        });

        wishlistStore.setCount(response.data.length); 
      } catch (error) {
        console.error("Erreur lors de la récupération de la wishlist :", error);
      }
    },
  },

  mounted() {
    this.checkUserStatus();
    this.enableAutoTheme();
    this.getAllProducts();
    this.fetchWishlistCount(); 
    this.loadUserData();
  window.addEventListener("user-updated", this.loadUserData);
    
     const userData = sessionStorage.getItem("user");
  if (userData) {
    const user = JSON.parse(userData);
    this.isLoggedIn = true;
    this.userName = `${user.prenom || ""} ${user.nom || ""}`.trim();
    this.userRole = user.role; // récupère le rôle (client ou administrateur)
  }
  


  },


  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
     window.removeEventListener("user-updated", this.loadUserData);
  },

  watch: {
    $route() {
      this.checkUserStatus();
      this.fetchWishlistCount();
    },
  },
  
};
</script>


<style scoped>
/* Barre supérieure */
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 100px;
  background-color: #05305b;
  color:white;
  font-size: 13px;
  font-family: 'Helvetica Neue', sans-serif;
  border-bottom: 1px solid #ddd;
}

.contact-info {
  display: flex;
  gap: 15px;
}

.contact-info span {
  margin-right: 15px;
}

.social-icons a {
  color:white;
  font-size: 14px;
  margin-left: 10px;
  transition: color 0.3s;
}


.social-icons a:hover {
  color: #00c853;
}


.phone {
  color: white;
  font-size: 13px;
  transition: transform 0.3s, color 0.3s;
  animation: slideIn 0.5s ease-out;
}

.phone:hover {
  transform: scale(1.1);
  color: #00c853;
}


.header-middle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 200px;
  background-color: white;
  border-bottom: 1px solid #ddd;
  margin-right: 0px; 
  z-index: 1000;
}

.logo-container {
  display: flex;
  align-items: center;
  
}

.logo-image {
  height: 85px;
  transition: transform 0.3s;
}

.logo-image:hover {
  transform: scale(1.05);
}

.search-container {
  flex: 2;
  position: relative;
  display: flex;
  justify-content: center;
  margin-left: 100px;
}

.search-bar {
  width: 90%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding-right: 5px;
}

.search-icon {
  position: absolute;
  right: calc(5% + 0px);
  top: 50%;
  transform: translateY(-50%);
  color:  rgb(80, 173, 235); 
  cursor: pointer;
  transition: color 0.3s;
}

.search-icon:hover {
  color: #004099; 
}

.user-options {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 30px; 
}

.option-item1 {
  display: flex;
  flex-direction: column; 
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 13px;
  transition: color 0.3s;
  font-family: 'Helvetica Neue', sans-serif;
    
}

.option-item1:hover {
  color: #0062cc;
}

.option-item1 {
  color: #333;
  text-decoration: none;
  display: flex;
  gap: 5px;
}


.cart-icon, .option-item i {
  font-size: 19px; 
  margin-bottom: 5px; 
  color: #78797a;
  
    
}
/* Bouton Shop en Ligne */
.shop-button {
  display: inline-block;
  padding: 10px 20px;
  background:  #e0240b;
  color: white;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  font-family: 'Helvetica Neue', sans-serif;
  margin-top: 0px;
  margin-left: 40px;
  
 
}

.shop-button:hover {
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(255, 117, 140, 0.4);
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 10px rgba(218, 63, 235, 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgb(87, 188, 171);
  }
}

.shop-button {
  animation: pulse 2s infinite;
}

.navbar {
  top: 161px; /* Place la navbar en dessous de la top-bar */
  left: 0%;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0px;
  background-color: white;
  color: #333;
  font-family: 'Helvetica Neue', sans-serif;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s, box-shadow 0.3s;
}

/*
.qr-code-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0px;

}*/


.qr-code-image {
  width: 85px; /* Ajuste la taille selon tes besoins */
  height: auto;
 
}

.qr-code-section p {
  font-size: 9px;
  margin-top: 0px;
}
.nav-links {
  list-style: none;
  display: flex;
  gap: 50px; 
  margin-bottom: 10px; 
  margin-top: 10px; 
  padding-left: 450px;
  
}

.nav-links li a {
  color: black;
  text-decoration: none;
  font-size: 16px;
  font-weight: 400;
  transition: color 0.3s;

}
.nav-links li a:hover {
  color: #0062cc;
}

.menu-button {
  display: none;
  background-color: transparent;
  border: none;
  color: #333;
  padding: 0 25px;
  cursor: pointer;
  font-size: 30px;
  z-index: 1200;
}

.cart-count {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 5px;
  font-size: 12px;
  font-weight: bold;
}

/* ===== Animation d’apparition/disparition douce ===== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ===== Icône WhatsApp ===== */
.whatsapp-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25D366;
  color: white;
  font-size: 35px;
  text-decoration: none;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s, transform 0.3s;
  z-index: 1500;
}

.whatsapp-icon:hover {
  background-color: #128C7E;
  transform: scale(1.1);
}

/* Mode sombre */
@media (prefers-color-scheme: dark) {
  .whatsapp-icon {
    background-color: #20b358;
  }
  .whatsapp-icon:hover {
    background-color: #128c7e;
  }
}

.user-dropdown {
  position: relative;
}

.option-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-transform: uppercase;
  font-weight: bold;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  transition: transform 0.2s ease, color 0.2s ease;
}

.option-item:hover {
  transform: scale(1.05);
  color: #3498db; /* couleur au survol (bleu par exemple) */
}

.option-item i {
  font-size: 24px;
  margin-bottom: 5px;
  transition: color 0.2s ease;
}

.option-item span {
  font-size: 12px;
  transition: color 0.2s ease;
}

.link-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: inherit;
}

.link-content:hover {
  color: #3498db;
}
.user-dropdown .dropdown-menu {
  z-index: 9999;
  position: absolute;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  min-width: 200px;
  padding: 10px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s;
}

.user-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu li {
  list-style: none;
}

.dropdown-menu li a {
  display: block;
  padding: 10px 20px;
  color: #333;
  text-decoration: none;
  transition: background-color 0.3s;
}

.dropdown-menu li a:hover {
  background-color: #f0f0f0;
  color: #0066cc;
}


/* ===== Icône Favoris ===== */
.wishlist-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 13px;
  transition: color 0.3s, transform 0.3s;
  position: relative;
}

.icon-badge-wrapper {
  position: relative;
  display: inline-block;
}

.wishlist-icon i {
  font-size: 19px;
  color: #e0245e; /* rouge cœur */
  margin-bottom: 5px;
}

.wishlist-icon:hover {
  transform: scale(1.1);
  color: #e0245e;
}

.badge {
  position: absolute;
  top: -6px;
  right: -8px;
  background-color: #e0245e;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: bold;
  line-height: 1;
  min-width: 16px;
  text-align: center;
}


/*  Mode sombre */
@media (prefers-color-scheme: dark) {
  .wishlist-icon {
    color: #e6edf1;
  }

  .wishlist-icon i {
    color: #ff7b9c;
  }

  .wishlist-icon:hover {
    color: #ff9bb3;
  }

  .badge {
    background-color: #ff7b9c;
    color: #0f141b;
  }
}



/* Responsive Styles */

@media only screen and (max-width: 1040px) {
  .top-bar {
    display: none;
  }

  .header-middle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    position: relative;
    z-index: 1000;
  }

  .logo-container {
    margin: 0 auto;
  }

  .search-container {
    margin-top: 10px;
    margin-left: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  /* Icône mon panier en haut à droite */
  .user-options {
    display: block;
    justify-content: flex-end;
    position:absolute;
    top: -15px;
    right: 10px;
    z-index: 1200;
  }

  /* Masquer Connexion et Utilisateur en responsive */
  .option-item1,
  .user-dropdown {
    display: none !important;
  }

  .nav-links li a {
    font-size: 13px;
  }

  .menu-button {
    display: block;
    font-size: 30px;
    position: absolute;
    top: 45px;
    left: 0px;
    color: #333;
    z-index: 1200;
  }

  .navbar {
    flex-direction: column;
    align-items: center;
    padding: 0px;
  }

  .nav-links {
    display: none;
  }

  .nav-active {
    display: flex;
    flex-direction: column;
    gap: 15px;
    background-color: white;
    padding: 10px 0;
    width: 100%;
  }

  .nav-links li:last-child {
    display: block;
  }

  .option-item span {
    display: none;
  }

  .shop-button {
    display: none;
  }

  .option-item {
    padding: 8px 12px;
    font-size: 14px;
    
  }

  .dropdown-menu {
    min-width: 180px;
  }
}

@media only screen and (max-width: 450px) {
  .header-middle {
    padding: 5px;
  }

  .search-container {
    width: 90%; /* Occupe tout l'espace sur les très petits écrans */
  }

  .nav-links li a {
 
  font-size: 13px;

}
  .menu-button {
   font-size: 22px;
   padding:10px 5px;
   top: 30px;
   z-index: 1200;
  
  }

  /* Icône mon panier à droite */
 .cart-icon {
    position: absolute;
    top: 45px;
    right: 10px; 
    display: flex;
    gap: 10x;
  }
    .option-item span { 
    display: none; /* Cache le texte "MON PANIER" sur les très petits écrans */
  }
    .shop-button {
    display: none;
  }
    .option-item {
    padding: 6px 8px;
    font-size: 10px;
  }
  .dropdown-menu {
    position: fixed;
    top: 60px; /* Ajuster en fonction de ton header */
    right: 10px;
    width: 90%;
    min-width: unset;
    padding: 15px 0;
  }

} 

/* ===== Thème clair par défaut ===== */
:root{
  --brand:#00998B;
  --accent:#e0240b;
  --bg:#181133;
  --surface:#ffffff;
  --text:#111827;
  --muted:#6b7280;
  --border:#e5e7eb;
  --shadow:0 2px 12px rgba(0,0,0,.06);
  --topbar-bg:#0b3a63;
  --topbar-text:#ffffff;
  --link:#0f62fe;
  --link-hover:#0043ce;
  --focus-ring: 0 0 0 4px color-mix(in srgb, var(--brand) 28%, transparent);
}

/* ===== Thème sombre appliqué automatiquement par le script ===== */
:root[data-theme="dark"]{
  --bg:#020c17;
  --surface:#10151c;
  --text:#061532;
  --muted:#9ca3af;
  --border:#1f2937;
  --shadow:0 6px 20px rgba(0,0,0,.45);

  --topbar-bg:#091b2f;
  --topbar-text:#dfe8ff;

  --link:#8ab4ff;
  --link-hover:#a8c7ff;
}

/* Animation douce lors du switch automatique */
:root.theme-fade *{
  transition: background-color .2s ease, color .2s ease, border-color .2s ease, box-shadow .2s ease !important;
}
@media (prefers-reduced-motion: reduce){
  :root.theme-fade *{ transition:none !important; }
}

/* ====== Applique les variables à tes blocs ====== */
.top-bar{
  background:var(--topbar-bg);
  color:var(--topbar-text);
  border-bottom:1px solid var(--border);
}
.header-middle{
  background:var(--surface);
  border-bottom:1px solid var(--border);
  box-shadow:var(--shadow);
}
.navbar{
  background:var(--surface);
  color:var(--text);
  box-shadow:var(--shadow);
}
.nav-links li a{
  color:var(--text);
}
.nav-links li a:hover{
  color:var(--brand);
  border-color:var(--brand);
}
.search-bar{
  background:var(--bg);
  color:var(--text);
  border:1px solid var(--border);
}
.search-bar:focus{
  border-color:var(--brand);
  box-shadow:var(--focus-ring);
}
.option-item1,.option-item{ color:var(--text); }
.option-item i,.option-item1 i{ color:var(--brand); }
.dropdown-menu{
  background:var(--surface);
  color:var(--text);
  border:1px solid var(--border);
  box-shadow:var(--shadow);
}
.dropdown-menu li a:hover{
  background: color-mix(in srgb, var(--brand) 10%, transparent);
  color:var(--brand);
}
.shop-button{
  background:var(--accent);
  color:white;
}

/* ====== Tablette ====== */
@media (max-width:1024px){
  .top-bar{ display:none; }
  .header-middle{
    gap:12px;
    padding:10px 20px;
  }
  .logo-image{ height:60px; }
  .search-container{ margin-left:0; width:100%; }
  .user-options{ position:absolute; right:10px; gap:8px; }
  .shop-button{ display:none; }
  .menu-button{
    display:block; position:absolute; top:52px; left:8px; z-index:1200;
    color:var(--text);
  }
  .navbar{ flex-direction:column; align-items:center; }
  .nav-links{ display:none; gap:18px; padding-left:0; }
  .nav-active{ display:flex; flex-direction:column; width:100%; padding:12px 0; background:var(--surface); }
  .nav-links li a{ font-size:14px; }
}

/* ====== Mobile ====== */
@media (max-width:600px){
  .header-middle{ padding:8px 10px; }
  .logo-image{ height:52px; }
  .search-container{ width:100%; }
  .option-item span{ display:none; }     /* on garde les icônes, on masque le texte */
  .nav-links li a{ font-size:13px; }
  .menu-button{ font-size:24px; top:44px; color:var(--text); }
}


/* Section icônes utilisateur (panier, favoris, compte) */
.user-options {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px; /* espace égal entre chaque bloc */
}

/* Style commun pour chaque icône + texte */
.option-item1, 
.wishlist-icon, 
.user-dropdown button {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  background: none;
  border: none;
  color: #222;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.option-item1 i,
.wishlist-icon i,
.user-dropdown i {
  font-size: 22px;
  margin-bottom: 6px;
  color: #333;
}

.option-item1:hover,
.wishlist-icon:hover,
.user-dropdown button:hover {
  color: #00998B; /* ta couleur principale */
  transform: scale(1.05);
}

.option-item1:hover i,
.wishlist-icon:hover i,
.user-dropdown button:hover i {
  color: #00998B;
}

/*  Style du badge de favoris */
.wishlist-icon .badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background-color: #e0245e;
  color: #fff;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 5px;
}

/* Mode sombre */
@media (prefers-color-scheme: dark) {
  .option-item1, 
  .wishlist-icon, 
  .user-dropdown button {
    color: #e6edf1;
  }
  .option-item1 i,
  .wishlist-icon i,
  .user-dropdown i {
    color: #d1d5db;
  }
  .option-item1:hover,
  .wishlist-icon:hover,
  .user-dropdown button:hover {
    color: #00b5a1;
  }
  .wishlist-icon .badge {
    background-color: #ff7b9c;
    color: #0f141b;
  }
}


</style>
<style>
/* ===== Thème clair (défaut) ===== */
:root{
  --brand:#00998B;
  --accent:#e0240b;

  --bg:#ffffff;           /* fond de page (body) */
  --surface:#ffffff;      /* cartes / barres */
  --text:#111827;         /* texte principal */
  --muted:#6b7280;        /* texte secondaire */
  --border:#e5e7eb;       /* bordures */
  --shadow:0 2px 12px rgba(0,0,0,.06);

  --topbar-bg:#0b3a63;
  --topbar-text:#ffffff;

  --link:#0f62fe;
  --link-hover:#0043ce;

  --focus-ring: 0 0 0 4px color-mix(in srgb, var(--brand) 28%, transparent);
}

/* ===== Thème sombre (appliqué par data-theme="dark" sur <html>) ===== */
:root[data-theme="dark"]{
  --bg:#0b0f14;
  --surface:#10151c;
  --text:#e5e7eb;         
  --muted:#9ca3af;
  --border:#1f2937;
  --shadow:0 6px 20px rgba(0,0,0,.45);

  --topbar-bg:#091b2f;
  --topbar-text:#dfe8ff;

  --link:#8ab4ff;
  --link-hover:#a8c7ff;
}

/* Animation douce au switch */
:root.theme-fade *{
  transition: background-color .2s ease, color .2s ease, border-color .2s ease, box-shadow .2s ease !important;
}
@media (prefers-reduced-motion: reduce){
  :root.theme-fade *{ transition:none !important; }
}

/* Base page */
html, body{
  background: var(--bg);
  color: var(--text);
}

/* ===== Bouton Menu fixe ===== */
.menu-floating {
  position: fixed;
  top: 18px;
  left: 18px;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: var(--surface);
  color: var(--brand-dark);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  display: grid;
  place-items: center;
  font-size: 22px;
  cursor: pointer;
  z-index: 2000; /* reste au-dessus de tout */
  transition: all 0.25s ease;
}

/* Effet au survol */
.menu-floating:hover {
  transform: scale(1.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

/* Icône à l’intérieur */
.menu-floating i {
  transition: transform 0.3s ease;
}

.menu-floating:hover i {
  transform: rotate(90deg);
}

/* Cacher le bouton sur les grands écrans */
@media (min-width: 1040px) {
  .menu-floating {
    display: none;
  }
}

/* ===== Mode sombre ===== */
@media (prefers-color-scheme: dark) {
  .menu-floating {
    background: #0f1720;
    color: #e6edf1;
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  }

  .menu-floating:hover {
    background: #142231;
    color: #73d8cf;
  }
}

/* ===== Variables */
:root{
  --brand:#00998B;
  --brand-dark:#05305b;
  --ink:#22313a;
  --muted:#6b7a86;
  --surface:#ffffff;
  --bar:#05305b;
}

/* ===== Layout helpers */
.container{ max-width:1200px; margin:0 auto; padding:0 18px; }

/* ===== Top bar */
.top-bar{
  background: var(--bar);
  color:#fff;
  font-size: 13px;
  border-bottom: 1px solid rgba(255,255,255,.12);
}
.top-bar__row{
  display:flex; align-items:center; gap:12px; padding:8px 0;
}
.contact-info{ display:flex; flex-wrap:wrap; gap:14px; }
.contact-info i{ margin-right:6px; }
.hours{ opacity:.95; white-space:nowrap; }
.social-icons{ margin-left:auto; display:flex; gap:10px; }
.social-icons a{ color:#e8f5f5; transition:opacity .2s ease, transform .15s ease; }
.social-icons a:hover{ opacity:1; transform:translateY(-1px); }

/* ===== Navbar */
.navbar{
  position: sticky; top:0; left:0; z-index:1000;
  background:#fff;
  transition: box-shadow .2s ease, background .2s ease, border-color .2s ease;
  border-bottom:1px solid rgba(0,0,0,.06);
}
.navbar--scrolled{
  box-shadow: 0 10px 28px rgba(0,0,0,.08);
  background:#fff;
}
.navbar__row{
  display:flex; align-items:center; justify-content:space-between; gap:16px; min-height:72px;
}
.logo-container{ display:flex; align-items:center; }
.logo-image{ height:72px; width:auto; display:block; }

/* Links */
.nav-links{
  list-style:none; display:flex; align-items:center; gap:26px; margin:0;
}
.nav-links a{
  color:var(--ink); text-decoration:none; font-size:15px; font-weight:600; letter-spacing:.01em;
  position:relative; padding:8px 2px; display:inline-flex; align-items:center; gap:8px;
}
.nav-links a::after{
  content:""; position:absolute; left:0; bottom:0; height:2px; width:0%;
  background: var(--brand); transition: width .22s ease;
}
.nav-links a:hover::after,
.nav-links a.router-link-exact-active::after{ width:100%; }
.nav-links a.router-link-exact-active{ color: var(--brand-dark); }

/* CTA Shop & Compte */
.nav-cta .btn-shop{
  display:inline-flex; align-items:center; gap:8px;
  background: linear-gradient(180deg, var(--brand), #028c7f);
  color:#fff; padding:10px 14px; border-radius:12px; font-weight:800;
  box-shadow:0 10px 22px rgba(0,153,139,.2);
  transition: transform .15s ease, box-shadow .2s ease, filter .2s ease;
}
.nav-cta .btn-shop:hover{ transform:translateY(-1px); box-shadow:0 14px 28px rgba(0,153,139,.28); filter:brightness(1.03); }
.nav-account a{ color:var(--brand-dark); font-weight:700; }

/* Burger */
.menu-button{
  display:none; background:transparent; border:0; font-size:26px; padding:8px; color:var(--ink); cursor:pointer;
}

/* Drawer mobile */
.nav-backdrop{
  position:fixed; inset:0; background:rgba(0,0,0,.35);
  backdrop-filter: blur(2px);
}
.no-scroll{ overflow:hidden; } /* body lock */

@media (max-width: 1040px){
  .top-bar{ display:none; }
  .menu-button{ display:block; }
  .logo-image{ height:58px; }

  .nav-links{
    position: fixed; top:0; right:0; height:100vh; width:min(78vw, 360px);
    background:#fff; flex-direction:column; align-items:flex-start;
    padding:84px 18px 18px; gap:16px; margin:0;
    box-shadow: -12px 0 28px rgba(0,0,0,.12);
    transform: translateX(100%); transition: transform .25s ease;
  }
  .nav-active{ transform: translateX(0%); }
  .nav-links li{ width:100%; }
  .nav-links a{ width:100%; padding:12px 6px; }
  .nav-cta, .nav-account a{ width:100%; }
  .nav-cta .btn-shop{ width:100%; justify-content:center; }
}

/* WhatsApp FAB */
.whatsapp-icon{
  position:fixed; bottom:20px; right:20px; z-index:1001;
  width:52px; height:52px; display:grid; place-items:center;
  background:#25D366; color:#fff; border-radius:999px; font-size:26px;
  box-shadow:0 12px 26px rgba(0,0,0,.2); transition: transform .15s ease, filter .2s ease;
}
.whatsapp-icon:hover{ transform:translateY(-2px); filter:brightness(1.05); }

/* Focus visible (a11y) */
:focus-visible{
  outline: 3px solid rgba(0,153,139,.25);
  outline-offset: 2px;
}

/* Dark mode */
@media (prefers-color-scheme: dark){
  .top-bar{ background:#08263a; border-bottom-color: rgba(255,255,255,.08); }
  .navbar{ background:#0f1720; border-bottom-color: rgba(255,255,255,.06); }
  .navbar--scrolled{ box-shadow: 0 12px 32px rgba(0,0,0,.5); }
  .nav-links a{ color:#e6edf1; }
  .nav-links a::after{ background:#73d8cf; }
  .nav-links a.router-link-exact-active{ color:#a5f3ee; }
  .nav-links{ background:#0f1720; }
  .nav-backdrop{ background:rgba(0,0,0,.5); }
  .nav-cta .btn-shop{ box-shadow: 0 10px 24px rgba(0,0,0,.45); }
}




</style>
